// extracted by mini-css-extract-plugin
export var chevron = "_iv-3";
export var chevronRotated = "_iv-4";
export var image = "_iv-1";
export var imageContainer = "_iv-0";
export var shippingAddress = "_iv-2";